module.exports = __webpack_public_path__ + "static/media/search_icon--black.5f6da41d.svg";